import { createAction } from 'redux-actions';

export const clearItemSku = createAction('CLEAR_ITEM_SKU');
export const showAddItemSkuModal = createAction('SHOW_ADD_ITEM_SKU_MODAL');
export const hideAddItemSkuModal = createAction('HIDE_ADD_ITEM_SKU_MODAL');
